import React from 'react'

// import Hero from './Hero/Hero'
// import Step from './Step/Step'
// import How from './How/How'
// import Download from './Download/Download'
import App from '../../App'
import Faq from "./Faq"
function Home() {
  return (
<div>
    <App/>
    <Faq/>
</div>
 
  )
}

export default Home